import { createSelector } from "reselect";

import Store from "../../../../../../../../../redux/store";

import { getFlyerDetailPageState } from "../../../store/flyer-detail-page.store";
import { FlyerDetailPageState } from "../../../types/flyer-detail-page-state/flyer-detail-page-state.interface";

import { FlyerDetailPageFormPositionState } from "../types/flyer-detail-page-form-position-state/flyer-detail-page-form-position-state.interface";
import { FlyerDetailPagePositionForm } from "../types/flyer-detail-page-position-form.interface";

import * as actions from "./flyer-detail-page-form-position.actions";

export const getFlyerDetailPageFormPositionState = createSelector(
  getFlyerDetailPageState,
  (state?: FlyerDetailPageState) => state?.flyerDetailPageFormPositionState
);

export const getPosition = createSelector(
  getFlyerDetailPageFormPositionState,
  (state?: FlyerDetailPageFormPositionState) => state?.position || null
);

export const isLoading = createSelector(
  getFlyerDetailPageFormPositionState,
  (state?: FlyerDetailPageFormPositionState) => state?.isLoading || false
);

export function fetchPosition(positionId: number) {
  Store.dispatch(actions.fetchPosition(positionId));
}

export function save(changes: Partial<FlyerDetailPagePositionForm>) {
  Store.dispatch(actions.savePosition(changes));
}
